export default {
      id: "attention-thin-usage",
      viewBox: "0 0 46 40",
      url: __webpack_public_path__ + "sprite-46b249.svg#attention-thin-usage",
      toString: function () {
        return this.url;
      }
    }